import * as lookup from "../../static/lookup.json"

import Cookies from "js-cookie";

let a = ["", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
let b = ["", "", 20, 30, 40, 50, 60, 70, 80, 90]
export function insWords(num,full) {
  if (!num) {
    return
  }
  if(typeof num !== "string"){
    num = num.toString()
  }

  let val = num.replace(/,/g, "")

  num = parseInt(val)
  if ((num = num.toString()).length > 9) return "overflow"
  let n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/)
  if (!n) return
  var str = ""
  str +=
    n[1] != 0
      ? (a[Number(n[1])] || Number(b[n[1][0]] + a[n[1][1]])) + `${full ?" Crore":" Cr. "}`
      : ""
  str +=
    n[2] != 0 ? " " + (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + " Lacs " : ""
  str +=
    n[3] != 0
      ? " " +  (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + " Thousands "
      : ""
  //str += (n[4] != 0) ? (a[Number(n[4])] || Number(b[n[4][0]]) + Number(a[n[4][1]])) + ' hundred ' : '';
  //str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || parseInt(b[n[5][0]]+ Number(a[n[5][1]]))) + ' ' : '';
  return str
}

export function applyComma(val) {
  if (val) {
    if (typeof val !== "string") {
      val = val.toString();
    }

    // Remove existing commas from the string
    val = val.replace(/,/g, "");

    // Insert commas without using regex
    let amount = "";
    let counter = 0;
    let endIndex = val.length-1;
    let temp = "";
    let decimal=false;
    for(let i=val.length-1;i>=0;i--) {
        if(val[i] == ".") {
            decimal = true;
            endIndex = i-1;
            break;
        } else {
            temp += val[i];
        }
    }

    for (let i = endIndex; i >= 0; i--) {
      amount = val[i] + amount;
      counter++;

      // Insert a comma after every three digits
      if (counter === 3 && i !== 0) {
        amount = "," + amount;
        counter = 0;
      }
    }

    return amount + ((temp && decimal) ? `.${temp.split('').reverse().join('')}` : '');
  } else {
    return "";
  }
}




export function lineCapital(line){
  if(!line?.length){
    return ''
  }
  line = line.toLowerCase()
  let updatedLine = line[0].toUpperCase() + line.substr(1)
  return updatedLine
}

export function wordCapital(line){
  if(!line?.length){
    return ''
  }

  let separatedWords = line.split(' ')
  separatedWords = separatedWords.map(element => {
    element.toLowerCase()
    return lineCapital(element)
  });
  
  let updatedLine = separatedWords.join(' ')
  return updatedLine

}
const dontCapitalizeLabels = [
  "proposalType",
  "insuranceRepository",
  "coverOption",
  "relationshipWithBank",
  "typeBankAccountPremiumRemittance",
  "proposerNationality",
]

const dontCapitalizeLabelsSet = new Set(
  dontCapitalizeLabels.map(v => v.toLowerCase())
)

const dontCapitalizeLookupValuesSet = new Set()
dontCapitalizeLabels.forEach(key => {
  const entries = lookup[key]
  if (Array.isArray(entries) && entries[0] && typeof entries[0] === "object") {
    Object.values(entries[0]).forEach(val => {
      if (val !== null && val !== undefined) {
        dontCapitalizeLookupValuesSet.add(String(val).toLowerCase())
      }
    })
  }
})

export function formatLookupLabel(input) {
  if (input === null || input === undefined) return ""
  const raw = String(input)
  const trimmed = raw.trim()
  if (!trimmed) return raw

  const lowerTrimmed = trimmed.toLowerCase()

  // 1) If the label itself is in dontCapitalizeLabels, return as-is
  if (dontCapitalizeLabelsSet.has(lowerTrimmed)) {
    return trimmed
  }

  // 2) If the label is one of the values under a lookup
  //    whose key is in dontCapitalizeLabels (e.g. insuranceRepository),
  //    return as-is (so CDSL/KARVY/CAMS/NSDL stay unchanged)
  if (dontCapitalizeLookupValuesSet.has(lowerTrimmed)) {
    return trimmed
  }

  const hasLetter = /[A-Za-z]/.test(trimmed)
  const shouldTransform = hasLetter && trimmed === trimmed.toUpperCase()

  let out = shouldTransform
    ? trimmed
        .toLowerCase()
        .replace(/\b([a-z])/g, (_, c) => c.toUpperCase())
    : trimmed

  const acronyms = [
    "PAN",
    "GST",
    "ULIP",
    "KYC",
    "CKYC",
    "DOB",
    "NRI",
    "NPS",
    "IFSC",
    "MICR",
    "NEFT",
    "RTGS",
    "UPI",
    "EMI",
    "PIN",
    "SIP",
    "FATCA",
    "CRS",
    "PEP",
    "IRDAI",
  ]
  acronyms.forEach(a => {
    out = out.replace(new RegExp(`\\b${a}\\b`, "gi"), a)
  })

  return out
}


export function deepCopy(obj){
  return JSON.parse(JSON.stringify(obj))
}

export function addDaysToCurrentDate(days) {
  let currentDate = new Date();

  currentDate.setDate(currentDate.getDate() + days);

  let formattedDate = currentDate.toISOString().split('T')[0];

  return formattedDate;
}

export function formatDatetoDDMMYYY(date){
  const parts = date.split("-");
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function formatTime(inputTime) {
  const [hour, minute, period] = inputTime.split(/:|\s/);

  const formattedHour = hour.padStart(2, '0');
  const formattedMinute = minute.padStart(2, '0');

  const formattedTime = `${formattedHour}:${formattedMinute} ${period.toUpperCase()}`;

  return formattedTime;
}

export const maskInFormat = (dateOfTargetInEpoch) => {
  if (!dateOfTargetInEpoch){
    return ""
  }
  const date = new Date(dateOfTargetInEpoch);
  const fullYear = date.getFullYear();
  return fullYear ? `**/**/**${fullYear.toString().slice(2,4)}` : fullYear
}


export function maskAlternateCharsInEmail(email) {
  if (!email){
    return "";
  }
  if (!email.includes("@")){
    let maskedUsername = maskAlternateChars(email);
    return `${maskedUsername}`;
  }else{
    const [username, domain] = email.split('@');
    let maskedUsername = maskAlternateChars(username);
    return `${maskedUsername}@${domain}`;
  }
}

function maskAlternateChars(str) {
  if (str.length === 1) {
    return '*'; 
  }

  let maskedStr = '';
  for (let i = 0; i < str.length; i++) {
    if (i % 2 === 0) {
      maskedStr += str[i];
    } else {
      maskedStr += '*';
    }
  }
  return maskedStr;
}

export function calculateAge(dobEpoch) {
  const dob = new Date(dobEpoch * 1000); // Convert epoch to date
  const now = new Date(); // Current date
  let age = now.getFullYear() - dob.getFullYear();
  
  const monthDiff = now.getMonth() - dob.getMonth();
  const dayDiff = now.getDate() - dob.getDate();
  
  // If the current month and day are before the DOB month and day, subtract 1 from age
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }
  
  return age;
}



export function setCookiesFromBackend(cookies = []) {
  if (!Array.isArray(cookies)) return;

  cookies.forEach((cookie) => {
    const {
      name,
      value,
      options = {},
    } = cookie;

    if (!name) return;

    // Defensive defaults
    const safeOptions = {
      path: "/",
      ...options,
    };
    Cookies.set(name, value, safeOptions);
  });
}

export function clearAllCookies() {
  if (window.document){
    const cookies = document.cookie.split(";");
  
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        name +
        "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  }
}